import * as React from 'react'
import styles from './highlightCard-style.css'
import Link from '@/components/Link/Link'
import cx from 'classnames'
import Icon from '@/components/Icon/Icon'
import { linkArrow } from '@/icons/index'
import { HighlightCardViewModel } from '@/view-models/HighlightCardViewModel'

type Props = {
  item: HighlightCardViewModel
}

type State = {}

// Editor can upload icons and change background color
class HighlightCard extends React.Component<Props, State> {
  static displayName = 'HighlightCard'
  static defaultProps = {}

  render() {
    const { item } = this.props

    if (!item) {
      return null
    }

    return (
      <Link
        {...item.link}
        noUnderline
        className={cx(styles.highlightCardContainer, {
          [styles.highlightCardActive]: item.link.active,
        })}
        styles={{backgroundColor: item.color}}
      >
        {item.icon && <span className={styles.highlightCardCustomIcon}
                            style={{
                            ...(item.icon?.position ? JSON.parse(item.icon.position) : {}) }}>
          <Icon iconSrc={item.icon?.src} width={item.icon?.size} height={item.icon?.size} /></span> }
        <div className={styles.highlightCardContenrWrapper}>

          <span>{item.link.label}</span>

          <div className={styles.highlightCardArrow}>
            <div className={styles.highlightCardArrowIcon}>
              <Icon iconSrc={linkArrow} width="16px" height="16px" />
            </div>
          </div>
        </div>
      </Link>
    )
  }
}

export default HighlightCard